export function smoothScrollTo(node, offset = 0) {
  const element = window.jQuery(node);
  const elementOffset = element.offset();

  window.jQuery('html, body').animate({ scrollTop: elementOffset.top - offset }, 'slow');
}
